import * as Types from '../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRoleNameFromUserIdVariables = Types.Exact<{
  input: Types.Scalars['ID']['input'];
}>;

export type GetRoleNameFromUserId = {
  userById: Pick<Types.User, 'id'> & { role: Pick<Types.Role, 'name'> };
};

export const GetRoleNameFromUserIdDocument = gql`
  query GetRoleNameFromUserId($input: ID!) {
    userById(id: $input) {
      id
      role {
        name
      }
    }
  }
`;

/**
 * __useGetRoleNameFromUserId__
 *
 * To run a query within a React component, call `useGetRoleNameFromUserId` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleNameFromUserId` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleNameFromUserId({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRoleNameFromUserId(
  baseOptions: Apollo.QueryHookOptions<GetRoleNameFromUserId, GetRoleNameFromUserIdVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRoleNameFromUserId, GetRoleNameFromUserIdVariables>(
    GetRoleNameFromUserIdDocument,
    options,
  );
}
export function useGetRoleNameFromUserIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRoleNameFromUserId, GetRoleNameFromUserIdVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRoleNameFromUserId, GetRoleNameFromUserIdVariables>(
    GetRoleNameFromUserIdDocument,
    options,
  );
}
export function useGetRoleNameFromUserIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRoleNameFromUserId,
    GetRoleNameFromUserIdVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRoleNameFromUserId, GetRoleNameFromUserIdVariables>(
    GetRoleNameFromUserIdDocument,
    options,
  );
}
export type GetRoleNameFromUserIdHookResult = ReturnType<typeof useGetRoleNameFromUserId>;
export type GetRoleNameFromUserIdLazyQueryHookResult = ReturnType<
  typeof useGetRoleNameFromUserIdLazyQuery
>;
export type GetRoleNameFromUserIdSuspenseQueryHookResult = ReturnType<
  typeof useGetRoleNameFromUserIdSuspenseQuery
>;
export type GetRoleNameFromUserIdQueryResult = Apollo.QueryResult<
  GetRoleNameFromUserId,
  GetRoleNameFromUserIdVariables
>;
export function mockGetRoleNameFromUserId({
  data,
  variables,
  errors,
}: {
  data: GetRoleNameFromUserId;
  variables?: GetRoleNameFromUserIdVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetRoleNameFromUserIdDocument, variables },
    result: { data, errors },
  };
}
